import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgCheckmarkRounded = (props: SVGProps<SVGSVGElement>) => (
    <svg
        height="16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        color="transparent"
        viewBox="0 0 16 16"
    >
        <path
            d="M2.33301 8.0013L6.33301 11.668L13.333 4.66797"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);

export const CheckmarkRoundedIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgCheckmarkRounded}
        fontSize={fontSize}
    />
);
